import http from "@/http-common";

/**
 * Service quản lý thành viên Gói Học Phí
 * Base URL: /web/receipt/v1/package-members
 */
class PackageMemberService {
  /**
   * Lấy danh sách thành viên đang có trong gói
   * @param {Object} params - { idPackage, idClass?, status?, fullName?, page, size }
   */
  getMembers(params) {
    return http.get("receipt/v1/package-members", { params });
  }

  /**
   * Lấy danh sách học sinh có thể thêm vào gói (chưa có trong gói)
   * @param {Object} params - { idPackage, idClass?, fullName?, page, size }
   */
  getAvailableStudents(params) {
    return http.get("receipt/v1/package-members/available", { params });
  }

  /**
   * Thêm học sinh vào gói
   * @param {Object} data - { idPackage, studentIds: Array<number>, enrollDate?: String }
   */
  addMembers(data) {
    return http.post("receipt/v1/package-members/add", data);
  }

  /**
   * Xóa học sinh khỏi gói
   * @param {Object} data - { idPackage, studentIds: Array<number>, deleteRevenue: boolean }
   */
  removeMembers(data) {
    // Axios delete method with body needs { data: data }
    return http.delete("receipt/v1/package-members/remove", { data });
  }
}

export default new PackageMemberService();
